import { render, staticRenderFns } from "./SessionExpiredBanner.vue?vue&type=template&id=879ce4fa"
import script from "./SessionExpiredBanner.vue?vue&type=script&lang=js"
export * from "./SessionExpiredBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports